export default [
    {
        number: "a",
        questions: ["111", "112", "113", "114", "115", "116"],
        secId: "core",
        subSecId: "11",
        title: "Need for Telehealth"
    }, {
        number: "b",
        questions: ["121", "122", "123", "124"],
        secId: "core",
        subSecId: "12",
        title: "Organizational Leadership Buy-In"
    }, {
        number: "a",
        questions: ["211", "212", "213", "214", "215"],
        secId: "finance",
        subSecId: "21",
        title: undefined
    }, {
        number: "a",
        questions: ["311", "312", "313", "314"],
        secId: "operations",
        subSecId: "31",
        title: "Telehealth Roles"
    }, {
        number: "b",
        questions: ["321", "322", "323", "324", "325"],
        secId: "operations",
        subSecId: "32",
        title: "Scheduling and Workflow"
    }, {
        number: "c",
        questions: ["331", "332", "333", "334"],
        secId: "operations",
        subSecId: "33",
        title: "Operational Requirements"
    }, {
        number: "d",
        questions: ["341", "342", "343", "344"],
        secId: "operations",
        subSecId: "34",
        title: "Assessment Approach"
    }, {
        number: "e",
        questions: ["351", "352", "353", "354"],
        secId: "operations",
        subSecId: "35",
        title: "Technology"
    }, {
        number: "f",
        questions: ["361", "362", "363"],
        secId: "operations",
        subSecId: "36",
        title: "Physical Space"
    }, {
        number: "a",
        questions: ["411", "412", "413"],
        secId: "staff",
        subSecId: "41",
        title: "Education and Awareness"
    }, {
        number: "b",
        questions: ["421", "422", "423", "424"],
        secId: "staff",
        subSecId: "42",
        title: "Innovators and Champions"
    }, {
        number: "a",
        questions: ["511", "512", "513", "514", "515"],
        secId: "patient",
        subSecId: "51",
        title: "Patient Engagement"
    }, {
        number: "b",
        questions: ["521", "522", "523"],
        secId: "patient",
        subSecId: "52",
        title: "Health Literacy"
    }
]


// WEBPACK FOOTER //
// ./src/data/subSections.js